import { styled } from '@mui/material/styles';

export const StyledPlaceholder = styled('div')<{
  disabled: boolean;
}>(({ disabled }) => ({
  color: disabled ? '#d2d4d7' : '#333333',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  width: 'calc(100% - 8px)',
}));
